import React from "react";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { FormSelectRow } from "./form-select-row";
import FormModalShell from "../ui/form-modal-shell";
import { CourierActions } from "../ui/courier-fields";

const AssignTripForm = ({
  closeModal,
  loading,
  apiError,
  trip,
  eligibleCouriers = [],
  assignCourierTrip
}) => (
  <FormModalShell title="Assign Courier" apiError={apiError} onClose={closeModal}>
      <Formik
        initialValues={{ courier: "" }}
        validationSchema={Yup.object().shape({
          courier: Yup.string().required("Required field")
        })}
        onSubmit={values => {
          assignCourierTrip({
            id: trip.id,
            data: { courier: Number(values.courier) }
          });
        }}
      >
        {formik => (
          <Form>
            <div className="form-row span-all">
              <p>Assign a courier to trip {trip && trip.code}.</p>
            </div>
            <FormSelectRow
              label="Eligible Courier"
              name="courier"
              value={formik.values.courier}
              onChange={e => formik.setFieldValue("courier", e.target.value)}
              error={formik.touched.courier && formik.errors.courier}
              required
              options={eligibleCouriers.map(c => ({
                value: c.id,
                label: c.fullName || c.phone
              }))}
            />
            {!eligibleCouriers.length && (
              <p className="courier-empty">No eligible couriers for this trip.</p>
            )}
            <CourierActions
              loading={loading}
              disabled={!eligibleCouriers.length}
              submitLabel="Assign"
              onCancel={closeModal}
            />
          </Form>
        )}
      </Formik>
  </FormModalShell>
);

export default AssignTripForm;
